package sarka.design.skoria.ui

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.size
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.jetbrains.compose.resources.painterResource
import sarka.design.skoria.presentation.RegisterUiState
import sarka.design.skoria.ui.composables.SkoriaPrimaryButton
import sarka.design.skoria.ui.composables.SkoriaTextField
import sarka.design.skoria.ui.theme.RCTheme
import skoria.composeapp.generated.resources.Res
import skoria.composeapp.generated.resources.skoria_logo

@Composable
fun RegisterScreen(
    state: RegisterUiState,
    onUsernameChange: (String) -> Unit,
    onEmailChange: (String) -> Unit,
    onPasswordChange: (String) -> Unit,
    onConfirmPasswordChange: (String) -> Unit,
    onRegister: () -> Unit,
    onRegistrationSuccess: (String, String) -> Unit,
    onBackToLogin: () -> Unit
) {
    LaunchedEffect(state.registrationSuccess) {
        if (state.registrationSuccess) {
            onRegistrationSuccess(state.username, state.email)
        }
    }

    Surface {
        Column(
            modifier = Modifier.fillMaxSize(),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Image(
                painter = painterResource(Res.drawable.skoria_logo),
                contentDescription = "Skoria Logo",
                modifier = Modifier.size(100.dp)
            )

            Spacer(modifier = Modifier.height(16.dp))

            Text(
                text = "Create Account",
                color = RCTheme.colors.primary,
                fontSize = 28.sp
            )

            Spacer(modifier = Modifier.height(24.dp))

            SkoriaTextField(
                hint = "Username",
                value = state.username,
                onValueChange = onUsernameChange,
                enabled = !state.isLoading
            )

            Spacer(modifier = Modifier.height(12.dp))

            SkoriaTextField(
                hint = "Email",
                value = state.email,
                onValueChange = onEmailChange,
                enabled = !state.isLoading
            )

            Spacer(modifier = Modifier.height(12.dp))

            SkoriaTextField(
                hint = "Password",
                isPassword = true,
                value = state.password,
                onValueChange = onPasswordChange,
                enabled = !state.isLoading
            )

            Spacer(modifier = Modifier.height(12.dp))

            SkoriaTextField(
                hint = "Confirm Password",
                isPassword = true,
                value = state.confirmPassword,
                onValueChange = onConfirmPasswordChange,
                enabled = !state.isLoading
            )

            if (state.error != null) {
                Spacer(modifier = Modifier.height(8.dp))
                Text(
                    text = state.error,
                    color = RCTheme.colors.error,
                    fontSize = 14.sp
                )
            }

            Spacer(modifier = Modifier.height(24.dp))

            if (state.isLoading) {
                CircularProgressIndicator()
            } else {
                SkoriaPrimaryButton(
                    text = "Register",
                    onClick = onRegister
                )

                Spacer(modifier = Modifier.height(8.dp))

                TextButton(onClick = onBackToLogin) {
                    Text(
                        text = "Already have an account? Login",
                        color = RCTheme.colors.primary,
                        fontSize = 14.sp
                    )
                }
            }
        }
    }
}
